import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WebTranslationsEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import Edit from '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class WebTranslationsEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    inputDescription: MdsLax<InstanceType<typeof Edit>>;
    inputText: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.WebTranslations_LoadData>>>;
    inputTextMultiline: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.WebTranslations_LoadData>>>;
    inputNote: MdsLax<InstanceType<typeof Edit>>;

    inputIsMultiline: MdsLax<InstanceType<typeof CheckBox>>;
    inputNonDefault: MdsLax<InstanceType<typeof CheckBox>>;

    private _onChangeIsMultiline(e: boolean): void {
        console.log("change", e);
        this.inputText.setReadonly(e);
        this.inputTextMultiline.setReadonly(!e);
    } 

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        console.log(this.getAttributeValue("is_multiline"));
        this._onChangeIsMultiline(this.getAttributeValue("is_multiline"));

        this.hideNode(this.inputDescription, true);
        this.inputDescription.destroy();
    }

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        this.entityClass = MainCatalogs_Classes.WebToolTranslations;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(WebTranslationsEditor);